import styled, { StyledProps } from 'styled-components/macro';

export type SelectProps = StyledProps<{}>;
export type SelectControlProps = StyledProps<{
  isDisabled?: boolean;
  hasError?: boolean;
  variant?: string;
  size?: string;
  styles?: any;
}>;
export type SelectInputProps = StyledProps<{
  size?: string;
  styles?: any;
}>;

export const Select = styled.div`
  width: 100%;
  position: relative;
  min-width: 120px;
`;

export const Label = styled.div<SelectProps>`
  font-size: 12px;
  line-height: 15px;
  color: #333333;
  margin-bottom: 2px;
  span {
    color: #cf4845;
    margin-right: 3px;
  }
`;

export const ErrorMessage = styled.div`
  position: absolute;
  bottom: -17px;
  left: 0;
  color: #cf4845;
  font-size: 12px;
`;

export const CheckboxLable = styled.div`
  margin-left: 8px;
  margin-top: 3px;
  font-size: 12px;
  color: #333;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const SingleValue = styled.div<SelectProps>`
  color: hsl(0, 0%, 20%);
  grid-area: 1/1/2/3;
  margin-left: 2px;
  margin-right: 2px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-sizing: border-box;
`;

// New Select
export const SelectWrapper = styled.div<{ width: string }>`
  width: 100%;
  position: relative;
  min-width: 120px;
  ${({ width = 'auto' }: any) => `width: ${width}`};
`;

export const SelectControl = styled.div<SelectControlProps>`
  ${({ variant, isDisabled, hasError }) => `
    height: ${variant === 'table' ? 'auto' : '30px'};
    min-height: ${variant === 'table' ? 'auto' : '30px'};
    border: 1px solid ${isDisabled ? '#D1D1D1' : '#c3cfd9'};
    box-shadow: ${
      hasError
        ? '2px 2px 0px #FFD6D7, -2px 2px 0px #FFD6D7, 2px -2px 0px #FFD6D7, -2px -2px 0px #FFD6D7, inset 0px 2px 2px rgba(0, 0, 0, 0.08)'
        : 'none'
    };
    padding: 0;
    outline: none;
    background: ${isDisabled ? '#E6E6E6' : '#fff'};
    cursor: pointer;
    overflow: hidden;
    border-radius: 3px;

    &:hover {
      border-color: rgb(38, 132, 255);
      // box-shadow: inset 0 0 0 1px rgb(38, 132, 255);
    }
  `}
`;

export const SelectInputContainer = styled.div<SelectProps>`
  display: flex;
  align-items: center;
  padding: 2px 8px;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
`;

export const SelectInput = styled.input<SelectProps>`
  color: inherit;
  background: 0px center;
  opacity: 1;
  width: 100%;
  grid-area: 1 / 2 / auto / auto;
  font: inherit;
  min-width: 2px;
  height: 100%;
  border: 0px;
  margin: 0px;
  outline: 0px;
  padding: 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* caret-color: transparent; */

  &:hover {
    cursor: pointer;
  }
`;

export const SelectIconContainer = styled.div<SelectInputProps>`
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 4px 0 8px;
`;

// Styled Input
export const SelectSome = styled.input<SelectInputProps>`
  ${({ styles, size }) => `
    font-size: ${size ? size : '14px'};
    color: #1D1E25;
    font-family: Roboto;
    margin: 0;
    padding: 0;
    ${styles && styles.input ? styles.input : ''}
  `}
`;

export const ClearIndicatorContainer = styled.div`
  color: ${(props) => props.theme.colors.gray};
  cursor: pointer;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SearchIndicatorContainer = styled.div`
  color: ${(props) => props.theme.colors.gray};
  cursor: pointer;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
